import { Routes, Route, Navigate } from 'react-router-dom';
import SessionPage from './pages/SessionPage';
import PageNotFound from './pages/PageNotFound';
import LinkExpired from './pages/LinkExpired';
import Privacy from './pages/Privacy';

function App() {
  return (
    <Routes>
      {/* Session route - the only valid path */}
      <Route path="/session/:sessionId" element={<SessionPage />} />

      {/* Link expired page */}
      <Route path="/link-expired" element={<LinkExpired />} />

      {/* Privacy notice page */}
      <Route path="/privacy" element={<Privacy />} />

      {/* Page not found */}
      <Route path="/not-found" element={<PageNotFound />} />

      {/* Redirect root to not-found (or you could show a landing page) */}
      <Route path="/" element={<Navigate to="/not-found" replace />} />

      {/* Catch all - redirect to not-found */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
